import { useDownloadEmissorOrderTaxInvoicePdfMutation } from '../services/contractOrderTaxInvoiceApi';
import { usePdfDownload } from './usePdfDownload';
export function useEmissorOrderTaxInvoicePdf(scopeKey = '') {
    const [trigger] = useDownloadEmissorOrderTaxInvoicePdfMutation();
    const { download, ...state } = usePdfDownload(trigger, scopeKey);
    return { downloadTaxInvoice: download, ...state };
}
